module.exports = __webpack_public_path__ + "img/building.952e2dba.png";